import React from 'react'

export const OptionsSvg = (props: any) => {
  return (
    <svg
      {...props}
      width="6"
      height="22"
      viewBox="0 0 6 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.625 3.23047C5.625 4.68022 4.44975 5.85547 3 5.85547C1.55025 5.85547 0.375 4.68022 0.375 3.23047C0.375 1.78072 1.55025 0.605469 3 0.605469C4.44975 0.605469 5.625 1.78072 5.625 3.23047ZM5.625 11.0053C5.625 12.4551 4.44975 13.6303 3 13.6303C1.55025 13.6303 0.375 12.4551 0.375 11.0053C0.375 9.55556 1.55025 8.38031 3 8.38031C4.44975 8.38031 5.625 9.55556 5.625 11.0053ZM3 21.3954C4.44975 21.3954 5.625 20.2202 5.625 18.7704C5.625 17.3207 4.44975 16.1454 3 16.1454C1.55025 16.1454 0.375 17.3207 0.375 18.7704C0.375 20.2202 1.55025 21.3954 3 21.3954Z"
        fill="#3E4685"
      />
    </svg>
  )
}
